import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';

const style = {
  button: {
    width: '100%',
  },
};

const Buttons = ({ back, isValid, handleSubmit, saveButtonTitle }) => {
  return (
    <Row gutter={10}>
      <Col span={12}>
        <Button onClick={back} style={style.button} data-test="cancel">
          Cancel
        </Button>
      </Col>
      <Col span={12}>
        <Button
          onClick={handleSubmit}
          type="primary"
          style={style.button}
          data-test="save"
          disabled={!isValid}
        >
          {saveButtonTitle}
        </Button>
      </Col>
    </Row>
  );
};

Buttons.propTypes = {
  back: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  saveButtonTitle: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
};

export default Buttons;
